import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ERROR_MESSAGE_TYPE } from '../../../models';

export interface InputErrorMessage {
  type: ERROR_MESSAGE_TYPE | string;
  data?: any;
}

@Component({
  selector: 'lib-error-message-wrapper',
  templateUrl: './error-message-wrapper.component.html',
  styleUrls: ['./error-message-wrapper.component.scss'],
})
export class ErrorMessageWrapperComponent {
  @Input() maxLength: number;

  @Input() control: AbstractControl;

  private orderedErrorTypePriority: ERROR_MESSAGE_TYPE[] = [
    ERROR_MESSAGE_TYPE.REQUIRED,
    ERROR_MESSAGE_TYPE.EMAIL,
    ERROR_MESSAGE_TYPE.MIN,
    ERROR_MESSAGE_TYPE.MAX,
    ERROR_MESSAGE_TYPE.MIN_LENGTH,
    ERROR_MESSAGE_TYPE.MAX_LENGTH,
    ERROR_MESSAGE_TYPE.MAX_NUMBER_SMS,
    ERROR_MESSAGE_TYPE.MUST_CONTAIN_CONTENT,
    ERROR_MESSAGE_TYPE.PASSWORD,
    ERROR_MESSAGE_TYPE.SAME_VALUE,
    ERROR_MESSAGE_TYPE.FORMAT,
    ERROR_MESSAGE_TYPE.NOT_EARLIER,
    ERROR_MESSAGE_TYPE.IN_RANGE,
    ERROR_MESSAGE_TYPE.CUSTOM,
  ];

  public get error(): InputErrorMessage {
    const errors = this.control?.errors;

    if (!errors) {
      return null;
    }

    for (let i = 0; i < this.orderedErrorTypePriority.length; i += 1) {
      const errorType = this.orderedErrorTypePriority[i];
      if (errors[errorType]) {
        return this.formatError(errorType, errors[errorType]);
      }
    }

    return null;
  }

  private formatError(
    errorType: ERROR_MESSAGE_TYPE | string,
    errorObject: any
  ): InputErrorMessage {
    return {
      type: errorType,
      data: { ...errorObject, value: this.control?.value },
    };
  }
}
